import React, { useEffect, useState } from "react";
import "../../assets/css/Profile.css";
import { checkInUser, checkOutUser, getUserAttendence } from "../../API/AttendenceApi"
import axios from 'axios';
import {
  Modal,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  Row,
  Col,
  Table,
} from 'reactstrap';
import dayjs from "dayjs";
import { useLoggedInUser } from "../../config/zStore";


// Office location for the "away from the office" check, from
// REACT_APP_OFFICE_LAT / REACT_APP_OFFICE_LNG. Unset means unknown.
const OFFICE_LOCATION = (() => {
  const lat = parseFloat(process.env.REACT_APP_OFFICE_LAT);
  const lng = parseFloat(process.env.REACT_APP_OFFICE_LNG);
  return Number.isFinite(lat) && Number.isFinite(lng) ? { lat, lng } : null;
})();

function Logs(props) {
  const [attendaces, setAttendaces] = useState(null);
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
const {userData} = useLoggedInUser()

  const getUserAttendaces = async () => {
    try {
      const userAttendaces = await getUserAttendence(userData._id);
      setAttendaces(userAttendaces);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    getUserAttendaces();
  }, [])

  // Function to calculate distance between two points using Haversine formula
  const  calculateDistance = (lat1, lon1, lat2, lon2) => {
    const R = 6371; // Radius of the Earth in kilometers
    const dLat = deg2rad(lat2 - lat1);
    const dLon = deg2rad(lon2 - lon1); 
    const a = Math.sin(dLat/2) * Math.sin(dLat/2) +
              Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * 
              Math.sin(dLon/2) * Math.sin(dLon/2); 
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
    const distance = R * c; // Distance in kilometers
    return distance;
  }

  // Function to convert degrees to radians
  const deg2rad = (deg) => {
    return deg * (Math.PI/180)
  }

  const fetchGeolocation = async () => {
    try {

      // The office location was hard-coded to 48.5759, 13.4497 - Passau,
      // Germany - so from the studio every check-in measured thousands of
      // kilometres "away". It is now configured; until it is, location is
      // treated as unknown and the person is asked.
      if (!OFFICE_LOCATION) return null;
      const response = await axios.get('https://ipapi.co/json/');
      const lat2 = Number(response.data?.latitude);
      const lon2 = Number(response.data?.longitude);
      if (!Number.isFinite(lat2) || !Number.isFinite(lon2)) return null;
      return calculateDistance(OFFICE_LOCATION.lat, OFFICE_LOCATION.lng, lat2, lon2);
    } catch (error) {
      console.error('Error fetching geolocation:', error);
      return null;
    }
  };

  const recordCheckIn = async (data = null) => {
    await checkInUser(data);
    getUserAttendaces();
  };

  // Ask before recording when the person seems to be away from the office, or
  // their location could not be determined. The question used to open at the
  // same moment an office check-in was recorded, so the answer changed nothing
  // (QA finding ATTEND-01) - and a failed lookup recorded "office" silently.
  const checkInHandler = async () => {
    const distance = await fetchGeolocation();
    if (distance === null || distance > 1) {
      setModal(true);
      return;
    }
    await recordCheckIn();
  };

  return (
    <div>
      {attendaces ? (
        <>
          <Row>
            <Col
              xs="12"
              style={{ paddingRight: "10%" }}
            >
              <div className="profileCard" style={{ marginLeft: 10, width: '100%', paddingTop: 6, paddingBottom: 10 }}>
                <div className="R_A_Justify p10">
                  <div className="Text14Semi">Mark Attendence</div>
                </div>
                <div className="line" />

                <div className="plt12" style={{ paddingTop: '15px' }}>
                  <Row>
                    <Col xs={12} sm={12} className="px-1 d-flex justify-content-center gap-2">
                      <Button style={{ width : '150px', fontSize: "0.8rem"}} className="submit_btn submit m-1" onClick={() => checkInHandler()}>
                        Check In
                      </Button>
                      <Button style={{ width : '150px', fontSize: "0.8rem"}} type="submit" className="submit_btn submit m-1"  onClick={async () => {
                        await checkOutUser();
                        getUserAttendaces();
                      }}>
                        Check Out
                      </Button>
                      <Button style={{ width : '150px', fontSize: "0.7rem"}} className="submit submit_btn ms-sm-4 m-1"   onClick={() => recordCheckIn({home:"yes"})}>
                        Check In (Home)
                      </Button>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
          <Table
            bordered
            hover
            borderless
            responsive
            style={{ width: '95%', marginTop: '15px' }}
          >
            <thead>
              <tr className="logsHeader Text16N1 gray2">
                <th className="tableBody">Date</th>
                <th className="tableBody">Check In Time</th>
                <th className="tableBody">Check Out Time</th>
                <th className="tableBody">Check In (Home)</th>
              </tr>
            </thead>
            <tbody
              className="Text12"
              style={{ textAlign: 'center', 
              borderWidth: '1px 1px 1px 1px',
            }}
            >
              {attendaces?.map((attendace, index) => (
                <tr>
                  <td
                    style={{ paddingTop: '15px', paddingBottom: '15px' }}
                    className="tableBody"
                  >
                    {dayjs(attendace.currentDate).format("DD-MMM-YYYY")}
                  </td>
                  <td
                    className="tableBody"
                    style={{ paddingTop: '15px', paddingBottom: '15px' }}
                  >
                    {attendace.checkInTime === "Not Marked" ? attendace.checkInTime : new Date(attendace.checkInTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true })}
                  </td>
                  <td
                    className="tableBody"
                    style={{ paddingTop: '15px', paddingBottom: '15px' }}
                  >
                    {attendace.autoCheckedOut ? "Not checked out" : attendace.checkOutTime === "Not Marked" ? attendace.checkOutTime : new Date(attendace.checkOutTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true })}
                  </td>
                  <td
                    className="tableBody"
                    style={{ paddingTop: '15px', paddingBottom: '15px' }}
                  >
                    {attendace.fromHome? "Yes" : "No"}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          <Modal
            isOpen={modal}
            toggle={toggle}
            centered={true}
            fullscreen="sm"
            size="sm"
          >
            <Form onSubmit={(e) => {
              e.preventDefault();
              setModal(false)
              recordCheckIn({home:"yes"})
            }}>
              <ModalBody>
                <Row className="p-3">
                  <Col xl="12" sm="12" lg="12" className="p-2">
                    <div className="label">Are you working from home?</div>
                  </Col>
                </Row>
              </ModalBody>
              <ModalFooter>
                <Button type='submit' className="Update_btn" >
                  Yes
                </Button>
                <Button type='button' color="danger" onClick={() => { setModal(false); recordCheckIn(); }}>
                  No
                </Button>
              </ModalFooter>
            </Form>
          </Modal>
        </>
      ) : (
        <div style={{ height: '400px' }} className='d-flex justify-content-center align-items-center'>
          <div className="spinner"></div>
        </div>
      )}

    </div>
  );
}

export default Logs;
